<app-admin-detail-shell
  titleKey="ADMIN.ROLES.DETAIL.CAPABILITIES.TITLE"
  descriptionKey="ADMIN.ROLES.DETAIL.CAPABILITIES.DESCRIPTION"
  [showBack]="true"
  [backLink]="backLink"
  [tabs]="tabs"
></app-admin-detail-shell>

